// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mr0K","content":"styles_content__1FlJe"};